<template>
  <div class="q-pa-xs">
    <div class="text-h6" :class="$q.dark.mode ? '' : 'text-primary'">
      <div v-if="timePeriod !== 'daily'" class="text-body2 q-pl-sm text-bold">
        as of: {{ asOfDate }}
      </div>
    </div>

    <PackageAuth>
      <template #authorized-content>
        <div class="row">
          <q-input
            v-if="timePeriod === 'daily'"
            dense
            filled
            v-model="toDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="toDate"
                @input="() => $refs.qDateProxy.hide()"
                @update:model-value="loadData(toDate)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-sm"
            />
          </q-input>

          <q-select
            outlined
            v-model="selectedPercentage"
            :options="['25', '30', '35', '40', '50']"
            dense
            label="Qnty % Gt Than"
            single
            class="q-mx-sm"
            style="width: 150px"
            :menu-absolute="true"
          />
          <q-select
            outlined
            v-model="selectedAmount"
            :options="['0', '50', '100', '200', '500', '1000']"
            dense
            label="Amt Gt Than"
            single
            class="q-mx-sm"
            style="width: 150px"
            :menu-absolute="true"
            bottom-slots
          >
            <template v-slot:hint>Amt Gt {{ selectedAmount }} Lakhs </template>
          </q-select>

          <q-select
            outlined
            v-model="sortBy"
            :options="['Qnty %', 'Amount']"
            dense
            label="Order By"
            single
            class="q-mx-sm"
            style="width: 100px"
            :menu-absolute="true"
            bottom-slots
          >
            <template v-slot:hint>Select Sort By </template>
          </q-select>

          <q-checkbox
            dense
            class="q-pl-sm q-pb-md ellipsis"
            v-model="mySignals"
            color="blue-5"
            keep-color
            label="My Signals"
          >
            <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
          </q-checkbox>
        </div>

        <div class="text-caption text-bold q-px-xs">
          1st Qnty % is greater than
          <span class="text-body2 text-bold">
            {{ selectedPercentage }} % ,
          </span>
          or the sum of the 1st two Qnty % is equal to or greater than
          <span class="text-body2 text-bold"> 50 % </span>
        </div>

        <q-card flat>
          <q-tabs
            v-model="tabs"
            dense
            outside-arrows
            mobile-arrows
            :class="
              $q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'
            "
            active-color="white"
            :active-bg-color="$q.dark.mode === true ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode === true ? 'grey-7' : 'blue-5'"
            inline-label
            align="justify"
            narrow-indicator
          >
            <q-tab name="buy-list" label="Buy List" no-caps />
            <q-tab name="sell-list" label="Sell List" no-caps />
            <q-tab name="hold-list" label="Hold List" no-caps />
            <q-tab name="release-list" label="Release List" no-caps />
          </q-tabs>

          <q-separator />

          <q-tab-panels v-model="tabs" animated>
            <q-tab-panel class="q-px-none q-py-xs" :name="tabs">
              <div class="row q-col-gutter-xs">
                <div class="col-12 col-sm-12">
                  <q-tabs
                    v-model="timePeriod"
                    dense
                    outside-arrows
                    mobile-arrows
                    :class="
                      $q.dark.mode === true
                        ? 'bg-grey-10'
                        : 'text-grey-9 bg-grey-4'
                    "
                    active-color="white"
                    :active-bg-color="
                      $q.dark.mode === true ? 'grey-9' : 'blue-4'
                    "
                    :indicator-color="
                      $q.dark.mode === true ? 'grey-7' : 'blue-5'
                    "
                    inline-label
                    align="justify"
                    narrow-indicator
                  >
                    <q-tab name="daily" label="Daily" no-caps> </q-tab>

                    <q-tab name="weekly" label="Weekly" no-caps />

                    <q-tab name="monthly" label="Monthly" no-caps />
                  </q-tabs>
                  <q-tab-panels v-model="timePeriod" animated>
                    <q-tab-panel class="q-px-none q-py-xs" :name="timePeriod">
                      <ListCard
                        class="q-mb-md"
                        :name="
                          tabs === 'buy-list'
                            ? 'Broker Buy Trend'
                            : tabs === 'sell-list'
                            ? 'Broker Sell Trend'
                            : tabs === 'hold-list'
                            ? 'Broker Hold Trend'
                            : tabs === 'release-list'
                            ? 'Broker Release Trend'
                            : ''
                        "
                        cv
                        :loading="loading"
                        :data="computedTableData.symbols"
                        :noHeader="false"
                        :weekly="false"
                        :type="
                          tabs === 'buy-list' || tabs === 'hold-list'
                            ? 'buy'
                            : 'sell'
                        "
                        :activeSymbol="computedTableData.activeSymbol"
                        @clickSymbol="
                          (eSymbol) => {
                            symbol = eSymbol;
                            computedTableData.activeSymbol = eSymbol;
                          }
                        "
                      />
                    </q-tab-panel>
                  </q-tab-panels>
                </div>
                <div class="col-12 col-sm-12">
                  <q-table
                    v-if="computedTableData.resultData.length > 0"
                    :class="
                      $q.dark.mode
                        ? 'table-sticky-header-column-dark'
                        : 'table-sticky-header-column'
                    "
                    flat
                    bordered
                    separator="cell"
                    :rows="computedTableData.resultData"
                    :columns="computedColumns"
                    :pagination="pagination"
                  >
                    <template v-slot:body-cell="props">
                      <q-td
                        :props="props"
                        :class="
                          props.rowIndex < 2 &&
                          (tabs === 'buy-list' || tabs === 'hold-list')
                            ? 'bg-green-4 text-white text-bold'
                            : props.rowIndex < 2 &&
                              (tabs === 'sell-list' || tabs === 'release-list')
                            ? 'bg-red-4 text-white text-bold'
                            : ''
                        "
                      >
                        {{ props.value }}
                      </q-td>
                    </template>
                    <template v-slot:body-cell-buyer="props">
                      <q-td
                        :props="props"
                        :class="
                          props.rowIndex < 2 &&
                          (tabs === 'buy-list' || tabs === 'hold-list')
                            ? 'bg-green-4 text-white text-bold'
                            : props.rowIndex < 2 &&
                              (tabs === 'sell-list' || tabs === 'release-list')
                            ? 'bg-red-4 text-white text-bold'
                            : ''
                        "
                      >
                        <q-item
                          class="justify-center"
                          dense
                          clickable
                          :to="{
                            path: '/brokers-analytics-pro',
                            query: {
                              brokerID: props.value,
                              transaction: 'Purchase',
                            },
                          }"
                        >
                          {{ props.value }}
                        </q-item>
                      </q-td>
                    </template>
                    <template v-slot:body-cell-seller="props">
                      <q-td
                        :props="props"
                        :class="
                          props.rowIndex < 2 &&
                          (tabs === 'buy-list' || tabs === 'hold-list')
                            ? 'bg-green-4 text-white text-bold'
                            : props.rowIndex < 2 &&
                              (tabs === 'sell-list' || tabs === 'release-list')
                            ? 'bg-red-4 text-white text-bold'
                            : ''
                        "
                      >
                        <q-item
                          class="justify-center"
                          dense
                          clickable
                          :to="{
                            path: '/brokers-analytics-pro',
                            query: {
                              brokerID: props.value,
                              transaction: 'Selling',
                            },
                          }"
                        >
                          {{ props.value }}
                        </q-item>
                      </q-td>
                    </template>
                    <template v-slot:bottom-row>
                      <q-tr :class="$q.dark.mode === true ? '' : ' bg-grey-3'">
                        <q-td class="text-center" colspan="1">Total</q-td>
                        <td></td>
                        <q-td class="text-center">
                          {{
                            sumBy(
                              computedTableData.resultData,
                              "qnt_percentage"
                            ).toFixed(2)
                          }}
                        </q-td>
                        <q-td class="text-center">
                          {{
                            sumBy(
                              computedTableData.resultData,
                              "quantity"
                            ).toFixed(2)
                          }}
                        </q-td>
                        <td></td>
                        <q-td class="text-center">
                          {{
                            sumBy(
                              computedTableData.resultData,
                              "amount"
                            ).toFixed(2)
                          }}
                        </q-td>
                      </q-tr>
                    </template>
                    <template v-slot:body-cell-symbol="props">
                      <q-td
                        :props="props"
                        :class="
                          props.rowIndex < 2 &&
                          (tabs === 'buy-list' || tabs === 'hold-list')
                            ? 'bg-green-4 text-white text-bold'
                            : props.rowIndex < 2 &&
                              (tabs === 'sell-list' || tabs === 'release-list')
                            ? 'bg-red-4 text-white text-bold'
                            : ''
                        "
                      >
                        <q-item dense>
                          <div class="col">
                            {{ props.value }}
                            <q-tooltip>{{
                              allStocks.find(
                                (stock) => stock.symbol == props.value
                              )?.name
                            }}</q-tooltip>
                          </div>
                        </q-item>
                      </q-td>
                    </template>

                    <template v-slot:body-cell-qnt_percentage="props">
                      <q-td
                        :props="props"
                        :class="
                          props.rowIndex < 2 &&
                          (tabs === 'buy-list' || tabs === 'hold-list')
                            ? 'bg-green-4 text-white text-bold'
                            : props.rowIndex < 2 &&
                              (tabs === 'sell-list' || tabs === 'release-list')
                            ? 'bg-red-4 text-white text-bold'
                            : ''
                        "
                        align="center"
                      >
                        <q-linear-progress
                          size="25px"
                          stripe
                          :value="parseFloat(props.row.qnt_percentage) / 100"
                          color="secondary"
                          class="q-mt-sm"
                        >
                          <div class="absolute-full flex flex-center">
                            <q-badge
                              color="white"
                              text-color="secondary"
                              :label="
                                props.row.qnt_percentage.toFixed(2) + ' %'
                              "
                            />
                          </div>
                        </q-linear-progress>
                      </q-td>
                    </template>
                  </q-table>
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </template>
    </PackageAuth>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, watchEffect } from "vue";
import useData from "src/use/data";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import ListCard from "src/components/ListCard.vue";
import { sumBy } from "lodash";
import PackageAuth from "src/components/Packages/PackageAuth";

const emit = defineEmits(["chartSymbol"]);

const $q = useQuasar();
const store = useStore();
const {
  buyerStockDateWise,
  sellerStockDateWise,

  netHoldingDateWise,
  netReleasedDateWise,
} = useData();

const allStocks = ref([]);
const mySignals = ref(false);
const mySignalsStocks = ref([]);

const toDate = ref("");
const asOfDate = ref("");
const buyData = ref([]);
const sellData = ref([]);
const holdingData = ref([]);
const releaseData = ref([]);

const symbol = ref("");
const tabs = ref("buy-list");
const timePeriod = ref("daily");
const sortBy = ref("Amount");
const loading = ref(false);
const selectedPercentage = ref("35");
const selectedAmount = ref("0");
const processedData = ref({});

const filterStocksBySector = (data) => {
  const mutualFunds = new Set([13, 14, 15]);
  return data.filter((item) =>
    allStocks.value.some(
      (stock) => stock.symbol === item.symbol && !mutualFunds.has(stock.sector)
    )
  );
};

const processSymbolData = (data) => {
  const filteredData = filterStocksBySector(data);
  return filteredData.reduce((acc, { symbol, ...entry }) => {
    if (!acc[symbol]) acc[symbol] = [];
    acc[symbol].push({ symbol, ...entry });
    return acc;
  }, {});
};

const processData = (percentage, amount) => {
  const result = {};

  let getData = processedData.value;

  for (const [symbol, entries] of Object.entries(getData)) {
    const totalQuantity = entries.reduce(
      (sum, { quantity }) => sum + quantity,
      0
    );

    entries.forEach((entry) => {
      entry.qnt_percentage = (entry.quantity / totalQuantity) * 100;
    });

    entries.sort((a, b) => b.quantity - a.quantity);

    if (entries.length >= 1) {
      const sumTopOne = entries[0]?.qnt_percentage;
      const sumTopTwo = entries[0]?.qnt_percentage + entries[1]?.qnt_percentage;
      const amountTopOne = entries[0]?.amount;
      if (
        (sumTopTwo >= 50 || sumTopOne >= percentage) &&
        amountTopOne >= Number(amount) * 100000
      ) {
        result[symbol] = entries;
      }
    } else {
      result[symbol] = entries;
    }
  }

  return result;
};

function formatDate(date) {
  return date.toISOString().split("T")[0];
}

function calculateFromDate(toDateStr, tabValue) {
  const toDate = new Date(toDateStr);
  const fromDate = new Date(toDate);
  const daysToSubtract =
    tabValue === "daily"
      ? 0
      : tabValue === "weekly"
      ? 7
      : tabValue === "monthly"
      ? 30
      : 0;
  fromDate.setDate(fromDate.getDate() - daysToSubtract);
  return formatDate(fromDate);
}

const loadData = async (date) => {
  $q.loading.show({});
  loading.value = true;
  try {
    if (date) {
      const toDateStr =
        timePeriod.value === "daily"
          ? date.replaceAll("/", "-")
          : asOfDate.value.replaceAll("/", "-");
      const toDateObj = new Date(toDateStr);

      const toDate = formatDate(toDateObj);
      const fromDate = calculateFromDate(toDateStr, timePeriod.value);

      let fetchFunction;
      let dataHolder;

      switch (tabs.value) {
        case "buy-list":
          fetchFunction = buyerStockDateWise;
          dataHolder = buyData;
          break;
        case "sell-list":
          fetchFunction = sellerStockDateWise;
          dataHolder = sellData;
          break;
        case "hold-list":
          fetchFunction = netHoldingDateWise;
          dataHolder = holdingData;
          break;
        case "release-list":
          fetchFunction = netReleasedDateWise;
          dataHolder = releaseData;
          break;
        default:
          throw new Error("Invalid tab selection");
      }

      const response = await fetchFunction(fromDate, toDate);
      dataHolder.value = response.data;
      const currentData = getCurrentData();
      processedData.value = processSymbolData(currentData);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    $q.loading.hide();
    loading.value = false;
  }
};

const getCurrentData = () => {
  return (
    {
      "buy-list": buyData.value,
      "sell-list": sellData.value,
      "hold-list": holdingData.value,
      "release-list": releaseData.value,
    }[tabs.value] || []
  );
};

const computedTableData = computed(() => {
  const processDataResult = processData(
    selectedPercentage.value,
    selectedAmount.value
  );

  const sortedBy = (() => {
    switch (sortBy.value) {
      case "Qnty %":
        return "qnt_percentage";
      case "Amount":
        return "amount";
      default:
        return "amount";
    }
  })();

  const allSymbols = Object.entries(processDataResult);

  const sortedEntries = Object.fromEntries(
    allSymbols.sort(([, a], [, b]) => {
      const aValue = a[0]?.[sortedBy] ?? 0;
      const bValue = b[0]?.[sortedBy] ?? 0;
      return bValue - aValue;
    })
  );

  const symbols = mySignals.value
    ? Object.keys(sortedEntries).filter((stock) =>
        mySignalsStocks.value.includes(stock)
      )
    : Object.keys(sortedEntries);

  return {
    resultData: processDataResult[symbol.value] || [],
    symbols,
    activeSymbol: symbols[0] || "",
  };
});

watch(
  [timePeriod, tabs],
  ([newTimePeriod, newTabs], [oldTimePeriod, oldTabs]) => {
    loadData(toDate.value);
  }
);

const pagination = ref({
  sortBy: "quantity",
  descending: true,
  rowsPerPage: 10,
});

const columns = [
  {
    name: "symbol",
    required: true,
    label: "Symbol",
    field: "symbol",
    sortable: true,
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
  {
    name: "qnt_percentage",
    required: true,
    label: "Qnty %",
    field: "qnt_percentage",
    format: (val, row) => {
      return val?.toFixed(2) + " %";
    },
    align: "center",
  },
  {
    name: "quantity",
    required: true,
    label: "Quantity",
    field: "quantity",
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
  {
    name: "rate",
    required: true,
    label: "Rate",
    field: "rate",
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
  {
    name: "amount",
    required: true,
    label: "Amount",
    field: "amount",
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
];

const buyColumns = [
  ...columns.slice(0, 1),

  {
    name: "buyer",
    required: true,
    label: "Broker",
    field: "buyer",
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
  ...columns.slice(1),
];

const sellColumns = [
  ...columns.slice(0, 1),
  {
    name: "seller",
    required: true,
    label: "Broker",
    field: "seller",
    format: (val, row) => {
      return val;
    },
    align: "center",
  },
  ...columns.slice(1),
];

const computedColumns = computed(() => {
  return tabs.value === "buy-list" || tabs.value === "hold-list"
    ? buyColumns
    : tabs.value === "sell-list" || tabs.value === "release-list"
    ? sellColumns
    : [];
});

watchEffect(() => {
  if (symbol.value && symbol.value !== "") {
    emit("chartSymbol", symbol.value);
  }
});

onMounted(async () => {
  try {
    if (store.state.market.asOf) {
      asOfDate.value = store.state.market.asOf;
      toDate.value = asOfDate.value;
    } else {
      store.dispatch("market/marketStatusNew");
      asOfDate.value = store.state.market.asOf;
      toDate.value = asOfDate.value;
    }

    if (!store.state.core.allStocks?.length) {
      await store.dispatch("core/getAllStocks");
    }
    allStocks.value = store.state.core.allStocks || [];

    await store.dispatch("packages/getPackageStatus");
    const currentPackage = store.state.packages.packageStatus;
    mySignalsStocks.value = currentPackage.current_package.stocks;

    await loadData(toDate.value);
  } catch (error) {
    console.error("Error :", error);
  }
});
</script>
